Drupal.theme.rutherfordSpinner = () =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="icon spin"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" /></svg>`;

Drupal.theme.ajaxProgressIndicatorFullscreen = () =>
  `
<div class="full-screen-ajax-indicator u-fixed u-flex u-items-center u-justify-center u-pin u-z-1251">
  <div class="full-screen-ajax-indicator__container u-bg-primary u-flex u-items-center u-justify-center u-rounded u-rounded-full u-shadow-lg u-text-h5 u-text-white">
    <svg class="icon spin">
      <use xlink:href="/themes/custom/rutherford/dist/img/sprite/sprite.svg#feather--loader"></use>
    </svg>
  </div>
</div>
  `;

Drupal.theme.ajaxProgressThrobber = () =>
  `<div data-ajax-progress-throbber class="u-gap-1 u-flex u-mt-1"><div>${Drupal.theme.rutherfordSpinner()}</div><div>${Drupal.t(
    'Loading&hellip;',
  )}</div></div>`;
